/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Environment, ENVIRONMENT_CONFIG } from '@common/environment-shared';
import { HttpErrorHandler } from '@common/tech-shared';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { VorgangRepository } from './+state/vorgang.repository';
import { FachstelleGuard } from './fachstelle.guard';
import { VorgangService } from './vorgang.service';

@Injectable({ providedIn: 'root' })
export class VorgangHttpErrorService {
  private readonly errorHandler = inject(HttpErrorHandler);
  private readonly vorgangService = inject(VorgangService);
  private readonly router = inject(Router);
  private readonly envConfig: Environment = inject(ENVIRONMENT_CONFIG);

  constructor() {
    this.register();
  }

  register(): void {
    this.errorHandler.registerCustomHandling(VorgangRepository.GET_VORGANG, (errorResponse: HttpErrorResponse) => {
      this.vorgangService.clearVorgang();
      if (FachstelleGuard.isFachstelle(this.envConfig) && errorResponse?.status === HttpStatusCode.NotFound) {
        this.router.navigate(['/', 'zuarbeit-nicht-verfuegbar']);
      }
    });
  }
}
